// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"e6ed7f56","217":"2c21ab7a","305":"6d45ea98","320":"75d3df0f","629":"0c74d97e","773":"a63713b0","832":"df93abb1","900":"92aa701d","924":"3e134ba0"}[chunkId] + ".chunk.js";
};